import { defineStore } from 'pinia';
import { useUpdateStatusMap } from '../util';

export const useUpdateStatusStore = defineStore('updateStatus', () => {
  return useUpdateStatusMap(); // shared, reactive map instance
});
